export const GENERAL_ERROR = Symbol('GENERAL_ERROR')
export const ERROR_BADINPUT = Symbol('ERROR_BADINPUT')
export const ERROR_UNAVAILABLE = Symbol('ERROR_UNAVAILABLE')
export const ERROR_AUTH_SERVICE = Symbol('ERROR_AUTH_SERVICE')
export const ERROR_INVALID_TOKEN = Symbol('ERROR_INVALID_TOKEN')
export const ERROR_SENSITIVE_LOGIN_EXPIRED = 'sensitive.login.expired'
